import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import MicroserviceInstallation from 'pages/Hardware/Installer/MicroserviceInstallation';
import { getMSDataByEntity } from 'rdx/hardware/installer';

import MSConfigForm from './ConfigForm';

function SelectVersion({ microService }) {
  const { entity, msIsInstalled, installedVersion } = useSelector(
    getMSDataByEntity(microService),
  );

  return (
    <div>
      <div>
        <span className="mr-3">Micro-service:</span>
        <code>{`${entity || microService} ${installedVersion ?? ''}`}</code>
      </div>
      {msIsInstalled && (
        <MSConfigForm entity={entity} version={installedVersion} />
      )}
      <MicroserviceInstallation microService={microService} />
    </div>
  );
}

SelectVersion.propTypes = {
  microService: PropTypes.string.isRequired,
};

export default SelectVersion;
